<template>
  <div class="STUDENT">
    <div class="third">
      <div class="third-rea">
        <div class="third-btn">
          <div class="btn-left">检索条件</div>
          <div class="btn-right">
            <el-button class="btn-two" type="primary" @click="searchInput"
              >查询</el-button
            >
            <el-button class="btn-two" type="default" @click="resetInput"
              >重置</el-button
            >
          </div>
        </div>
        <div class="third-search">
          <el-form
            :inline="true"
            :model="formInline"
            label-width="76px"
            @keyup.native.enter="searchInput"
          >
            <div class="search-row">
              <div class="row-item">
                <el-form-item label="姓名" prop="name">
                  <el-input
                    class="item-input"
                    :maxlength="30"
                    v-model.trim="formInline.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="学号" prop="keyId">
                  <el-input
                    class="item-input"
                    :maxlength="30"
                    v-model.trim="formInline.keyId"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- <div class="row-item">
                <el-form-item label="考生号" prop="ksh">
                  <el-input
                    class="item-input"
                    :maxlength="30"
                    v-model="formInline.ksh"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div> -->
              <div class="row-item">
                <el-form-item label="校区" prop="campus">
                  <key-value-select
                    :className="'item-input'"
                    :isNeedAll="true"
                    v-model="formInline.campus"
                    placeholder="请选择"
                    methods="post"
                    :dictProp="{
                      data: 'result',
                      label: 'dictValue',
                      value: 'dictKey',
                    }"
                    dictUrl="/api/blade-workbench/eduCampusInfo/getCampusNameAndId"
                  ></key-value-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="层次" prop="hierarchy">
                  <key-value-select
                    :className="'item-input'"
                    :isNeedAll="true"
                    v-model="formInline.hierarchy"
                    placeholder="请选择"
                    dictUrl="/api/blade-workbench/dict/dictionary?code=hierarchy"
                  ></key-value-select>
                </el-form-item>
              </div>
            </div>
            <div class="search-row">

              <div class="row-item">
                <el-form-item label="年级" prop="grade">
                  <key-value-select
                    :className="'item-input'"
                    :isNeedAll="true"
                    v-model="formInline.grade"
                    placeholder="请选择"
                    :dictProp="{
                      data: 'result',
                      label: 'dictValue',
                      value: 'dictValue',
                    }"
                    dictUrl="/api/blade-workbench/dict/dictionary?code=grade"
                  ></key-value-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="院/专/班" prop="cascade">
                  <el-cascader
                    :options="newYXB"
                    class="item-input"
                    @change="handleChange"
                    v-model="formInline.cascade"
                    :props="{ checkStrictly: true }"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item
                  label="是否有照片"
                  prop="otherParam"
                >
                  <key-value-select
                      className="item-input"
                      :isNeedAll="true"
                      v-model="formInline.otherParam"
                      placeholder="请选择"
                      methods="post"
                      :isNeedCash="false"
                      :dict="[
                        { label: '是', value: 'hasPhoto' },
                        { label: '否', value: 'noPhoto' },
                      ]"
                    ></key-value-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="上传时间" prop="time">
                  <el-date-picker
                    style="width: 216px; padding-left: 15px; padding-right: 0"
                    class="list-input Isdaterange"
                    v-model="formInline.LastexecutionTime"
                    type="datetimerange"
                    unlink-panels
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="timestamp"
                    :picker-options="pickerOptions0"
                    @change="checkDate"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="third-one">
        <div class="third-do-btn">
          <div class="do-btn-left" style="width: 600px">
            <el-button
              class="do-btn-four"
              type="default"
              icon="el-icon-download"
              @click="addMember"
              >导入照片</el-button
            >
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-upload2"
              @click="outputData"
              >导出照片</el-button
            >
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-upload2"
              @click="daoChuShuJu"
              >导出没有照片的用户</el-button
            >
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-delete"
              @click="deleteItem(1)"
              >删除照片</el-button
            >
            <el-button
              class="do-btn-two"
              type="default"
              icon="el-icon-delete"
              @click="deleteItem(2)"
              >删除所有用户的照片</el-button
            >
          </div>
          <div
            class="do-btn-rightA"
            style="width: calc(100% - 600px); text-align: right; color: #76838f"
            v-if="isInformation"
          >
            <p>
              总计：<span>{{ totalLimit }}</span> ，有照片：<span
                >{{ reserveCount }}
              </span>
              ，无照片:
              <span @click='screenPhoto' class="error"
                >{{ verifiedCount }}
              </span>
            </p>
          </div>
        </div>
        <el-table
          :max-height="getMaxHeight(230)"
          class="third-tableThree messageHistory-threeLine"
          :data="tableData"
          row-key="studentId"
          border
          stripe
          @selection-change="handleSelectChange"
          @select-all="handleSelectAll"
          ref="studentId"
          v-loading="loading"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkboxSelect"
          >
          </el-table-column>
          <template v-for="(item, index) in ColumnList">
            <el-table-column
              v-if="item.needKeyValue"
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <key-value-span
                  :dict="item.dict"
                  :value="scope.row[item.key]"
                  :dictUrl="item.actionUrl"
                ></key-value-span>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item.isImgUrl"
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.imgUrl"
                  @click="viewImage(scope.row.imgUrl)"
                >
                  查看
                </el-button>
                <span v-else>暂无</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="item.key"
              :label="item.column"
              :key="index"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </template>
          <el-table-column
            min-width="100px"
            prop="address"
            label="操作"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteItem(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.imgUrl"
                >删除照片</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="third-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
      <notice-modal
        :noticeModalVisible="noticeModal"
        @noticeModalClose="closeNotice"
        @noticeModalAgree="agreeNotice"
        :noticeTitle="noticeTitle"
        :noticeSpec="noticeSpec"
        :noticeType="noticeType"
        :btnAgree="agreeContent"
        :noticeContent="noitceContent"
      ></notice-modal>
      <!-- 导出数据 -->
      <pull-Out-New
        :outputModal="outputModal"
        :isJS="isJS"
        :isGX="false"
        LBName="在校生"
        :identity="identity"
        :requestModel="formInline"
        :checkID="checkID"
        @closeNewTask="closeOutPut"
        biaotouURL="/api/blade-platform/userImg/excel/ExportField"
        daochuURL="/api/blade-platform/userImg/excel/export"
        lunxun="/api/blade-platform/userImg/excel/exportStatus"
        ExportCountURL="/api/blade-platform/userImg/excel/exportCount"
      ></pull-Out-New>
      <pull-Out-Zip
        :outputModal="outputModalZip"
        :identity="identity"
        LBName="在校生照片"
        :formInline="formInline"
        @closeNewTask="closeOutPutZip"
        :checkID="checkID"
        daochuURL="/api/blade-platform/userImg/exportImg"
        lunxun="/api/blade-platform/userImg/excel/exportPhoto"
        ExportCountURL="/api/blade-platform/userImg/exportImgCount"
      ></pull-Out-Zip>
      <pushInfoNewZip
        :importModal="importModal"
        @closeNewTask="closeImport"
        :identity="identity"
        IngURL="/api/blade-platform/userImg/importImg/polling"
        upFailURL="/api/blade-platform/userImg/downloadErrorExcel"
        DaoruURL="/api/blade-platform/userImg/importImg"
        @daoruSuccess="
          () => {
            roleStuList();
          }
        "
        modalTitle="上传照片"
      ></pushInfoNewZip>
      <preview-modal
      :previewModal="ImgDialog"
      :previewImageUrl="imgSrc"
      @previewClose="(()=>{
          ImgDialog = false
      })"
    ></preview-modal>
    </div>
  </div>
</template>
<script>
import { toDaoRuData } from "@/api/Daoru/daoru";
// import pushInfoNew from "./ExcelImport.vue";
import download from "@/api/downloadApp/download.js";
export default {
  name: "thirdThree",
  //   components: {
  //     pushInfoNew,
  //   },
  data() {
    return {
      identity: "STUDENT", //在校生:STUDENT,毕业生:GRADUATE_STUDENT,教工:TEACHER,其他:OTHER
      valNum: 0, // 初始化获取未核验的数据条数
      importModal: false, // 一键核验弹框
      totalLimit: 0, //允许校验次数
      reserveCount: 0, //已校验次数
      verifiedCount: 0, //等带校验

      radio: 1, //批量导出照片选项
      namingRule: 1, //批量导出照片命名规则
      imgFormat: 1, //批量导出照片格式
      input: "", //用户自定义数据名
      outImgNum: 0, //批量导出照片数据总量
      labelPosition: "right", //导入照片表单向右靠齐
      outputModalImg: false, //批量导出照片
      outputModalHuJiImg: false, //导出户籍照片

      mzdata: [], //民族数据
      imgSrc: "", //查看图片弹框图片地址
      ImgDialog: false, // 查看图片弹窗
      LBname: "", //导出弹框的前缀名字
      outputModal: false, //导出弹窗
      isJS: true, //是否有检索条件
      checkID: "", //表格选中的ID
      // importModal: false, //导入弹框
      isInformation: true, //校验信息是否显示提示框div
      loading: false,
      noticeSpec: "", // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "", // 提示信息
      noticeModal: false, // 提示弹窗
      pageSize: 40, //默认每页多少条
      pageNum: 1, //第几页
      totalNum: 0, // 数据总数
      tableData: [], //查询到的表格数据
      formInline: {
        otherParam: '',
        name: "", // 身份证号码
        keyId: "", //工号/学号
        ksh: "", // 考生号
        hierarchy: "", // 核验结果
        campus: "",
        grade: "", //核验设备
        LastexecutionTime: [], //时期选择器选择时间
        startTime: "", // 开始时间
        endTime: "", //结束时间,
        cascade: [], // 院/专/班
        college: null, // 院
        major: null, // 专
        className: null, // 班
      },
      selectArrList: [], // 批量选择数据
      nowSelectArr: [], // 移除数组
      isDeleteList: false, // 是否批量删除
      //======================
      newYXB: [], //院专班
      schoolList: [], // 校区列表
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < 1609430400000;
        },
      },
      //==============导出zip组件
      outputModalZip: false, //导出弹窗
      ColumnList: [
        {
          column: "学号",
          key: "keyId",
          needKeyValue: false,
          caseKey: "keyId",
        },
        {
          column: "姓名",
          key: "name",
          needKeyValue: false,
          caseKey: "name",
        },
        {
          column: "性别",
          key: "sex",
          needKeyValue: true,
          actionUrl: "/api/blade-workbench/dict/dictionary?code=sex",
          caseKey: "sex",
        },
        {
          column: "层次",
          key: "hierarchy",
          needKeyValue: true,
          actionUrl: "/api/blade-workbench/dict/dictionary?code=hierarchy",
          caseKey: "hierarchy",
        },
        {
          column: "年级",
          key: "grade",
          needKeyValue: false,
          caseKey: "grade",
        },
        {
          column: "校区",
          key: "campus",
          needKeyValue: false,
          caseKey: "campus",
        },
        {
          column: "院系",
          key: "college",
          needKeyValue: false,
          caseKey: "college",
        },
        {
          column: "专业",
          key: "major",
          needKeyValue: false,
          caseKey: "major",
        },
        {
          column: "班级",
          key: "className",
          needKeyValue: false,
          caseKey: "className",
        },
        {
          column: "照片",
          key: "imgUrl",
          needKeyValue: false,
          isImgUrl: true,
          caseKey: "imgUrl",
        },
        {
          column: "上传时间",
          key: "uploadTime",
          needKeyValue: false,
          caseKey: "uploadTime",
        },
        {
          column: "手机号",
          key: "tel",
          needKeyValue: false,
          caseKey: "tel",
        },
        {
          column: "备用号码",
          key: "backupNumber",
          needKeyValue: false,
          caseKey: "backupNumber",
        },
      ],
      imgSource:2,//上传照片来源
    };
  },
  async created() {
    this.roleStuList();
    await this.getCollegeMajorTree();
    this.getImgSource()
  },
  methods: {
    // 是否有照片筛选
    screenPhoto () {
      if (this.formInline.otherParam == 'noPhoto') {
        this.formInline.otherParam=''
      }else{
        this.formInline.otherParam='noPhoto'
      }
      this.roleStuList();
      console.log('是否有照片筛选');
    },
    //获取照片来源
    async getImgSource(){
        try {
            const parms = {
            // ids: index,
            identity: this.identity,
            };
            let {
            data: { status, msg, result },
            } = await this.$store.dispatch("getConfig", parms);
            if (status != 1000) {
            //   this.outImgNum = result;
            this.$message({
                type: "error",
                message: msg,
            });
            } else {
            console.log(result);
            this.imgSource = result.picUploadType
            }
        } catch (err) {
            console.log(err);
        }
    },
    checkboxSelect(row, index) {
      if (row.imgUrl) {
        return true; // 不禁用
      } else {
        return false; // 禁用
      }
    },
    //行政区域选中节点
    handleChange(value) {
      console.log(value);
      if (value.length > 0) {
        this.formInline.college = value[0];
      } else if (value.length > 1) {
        this.formInline.major = value[1];
      } else if (value.length > 2) {
        this.formInline.className = value[2];
      }
      //   this.formInline.college=value.length > 0
      //         ? value[0]
      //         : null, //院/专/班
      //     this.formInline.major=value.length > 1
      //         ? value[1]
      //         : null, //院/专/班
      //     this.formInline.className=value.length > 2 ? value[2]: null, //院/专/班
    },
    //删除用户照片
    async deleteItem(item) {
      if (item == 1 && this.checkID === "") {
        return this.$message.error("请选择数据");
      }
      console.log(item);
      this.agreeNotice = () => {
        this.noticeModal = false;
        if (item == 1) {
          this.deleteImg(this.checkID);
        } else if (item == 2) {
          this.deleteAllImg();
        } else {
          this.deleteImg(item.studentId);
        }
      };
      (this.noitceContent = "确定删除吗？"), // 提示信息
        (this.noticeSpec = this.imgSource==1? "删除照片后需用户重新上传，":"删除照片后需重新上传，"), // 标红提示
        (this.noticeModal = true);
      //   if (item == 1) {
      //     this.deleteImg(this.checkID);
      //   } else if (item == 2) {
      //     this.deleteImg(null);
      //   } else {
      //     this.deleteImg(item.studentId);
      //   }
    },
    //删除所有照片
    async deleteAllImg() {
      try {
        const parms = {
          identity: this.identity,
        };
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("deleteAllImg", parms);
        if (status != 1000) {
          //   this.outImgNum = result;
          this.$message({
            type: "error",
            message: msg,
          });
        } else {
          //   (this.outImgNum = 0), console.log(msg);
          this.$message.success("删除成功");
          this.roleStuList();
        }
      } catch (err) {
        console.log(err);
      }
    },
    //删除照片
    async deleteImg(index) {
      try {
        const parms = {
          ids: index,
          identity: this.identity,
        };
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("deleteImg", parms);
        if (status != 1000) {
          //   this.outImgNum = result;
          this.$message({
            type: "error",
            message: msg,
          });
        } else {
          //   (this.outImgNum = 0), console.log(msg);
          this.$message.success("删除成功");
          this.roleStuList();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取院专班
    async getCollegeMajorTree() {
      const getCollegeMajorTree = await this.$store.dispatch(
        "getCollegeMajorTree",
        {
          tenantId: this.$store.state.user.tenantId,
          campusId: this.formInline.campus,
        }
      );
      console.log("y元专版", getCollegeMajorTree);
      //   return;
      if (getCollegeMajorTree.data.status === 1000) {
        const arr = getCollegeMajorTree.data.result.college;
        const arrT = arr.map((item) => {
          if (item.major.length !== 0) {
            return {
              value: item.collegeId,
              label: item.collegeName,
              children: item.major,
            };
          } else {
            return {
              value: item.collegeId,
              label: item.collegeName,
            };
          }
        });
        arrT.forEach((element) => {
          if (element.children) {
            element.children = element.children.map((itemTwo) => {
              if (itemTwo.class.length !== 0) {
                return {
                  value: itemTwo.majorId,
                  label: itemTwo.majorName,
                  children: itemTwo.class,
                };
              } else {
                return {
                  value: itemTwo.majorId,
                  label: itemTwo.majorName,
                };
              }
            });
            element.children.forEach((elementT) => {
              if (elementT.children) {
                elementT.children = elementT.children.map((itemE) => ({
                  value: itemE.classId,
                  label: itemE.className,
                }));
              }
            });
          }
        });
        this.newYXB = [...arrT];
        console.log("this.newYXB", this.newYXB);
      } else {
        this.$message.error(getCollegeMajorTree.data.msg);
      }
    },
    getYjdrNum() {
      toDaoRuData(
        "/api/blade-faceCertification/api/faceBio/verifyRecord/registrationListByDate"
      ).then((res) => {
        const data = res.data;
        console.log("这是补充字段", data.result);
        if (data.status === 1000) {
          this.valNum = 0;
          data.result.forEach((el) => {
            this.valNum += el.count;
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 导入照片
    addMember() {
      this.importModal = true;
      // this.getCollegeMajorTree();
    },
    closeImport() {
      this.importModal = false;
    },
    //选择时间后处理时间
    checkDate() {
      console.log("选择的时间", this.formInline.LastexecutionTime);
    //   this.formInline.startTime = this.formInline.LastexecutionTime[0];
    //   this.formInline.endTime = this.formInline.LastexecutionTime[1];
    },
    viewImage(img) {
      //查看图片
      this.imgSrc = img  +'?'+ new Date().getTime();
      this.ImgDialog = true;
    },
    //开启导出数据
    daoChuShuJu() {
      this.LBname = "核验记录";
      this.outputModal = true;
    },
    //开启导出照片
    async outputData() {
      this.LBname = "核验记录";
      this.outputModalZip = true;
    },
    // 关闭导出
    closeOutPut() {
      this.outputModal = false;
    },
    // 改变导出照片
    closeOutPutZip() {
      this.outputModalZip = false;
    },
    //导入成功后刷新列表
    daoruSuccess() {
      this.resetForm("formInline");
      // this.selectList()
    },
    // 搜索
    searchInput() {
      this.pageNum = 1;
      this.roleStuList();
    },
    // 重置
    resetInput() {
      this.hignSearchRes = "";
      this.pageNum = 1;
      this.formInline = {
        name: "", // 身份证号码
        keyId: "", //工号/学号
        ksh: "", // 考生号
        hierarchy: "", // 核验结果
        otherParam: "", // 核验结果
        campus: "",
        grade: "", //核验设备
        LastexecutionTime: [], //时期选择器选择时间
        startTime: "", // 开始时间
        endTime: "", //结束时间,
        cascade: [], // 院/专/班
        college: null, // 院
        major: null, // 专
        className: null, // 班
      };
      this.roleStuList();
    },
    // 批量选中项变化
    handleSelectChange(selection) {
      console.log(selection);
      this.selectArrList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.selectArrList.push(selection[i].studentId);
      }
      this.checkID = this.selectArrList.join(",");
      console.log("这是我选择的选项", this.checkID);
    },
    //表格全选中
    handleSelectAll(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].studentId);
      }
      this.checkID = this.checkClassList.join(",");
      console.log("这是我的选项", this.checkClassList);
    },
    // 确认弹窗
    agreeNotice() {
      // this.roleLabelRemove();
      console.log("我是确认弹窗");
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    //改变每页显示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageNum = 1;
      this.pageSize = val;
      this.roleStuList();
    },
    //改变当前页数
    handleCurrentChange(val) {
      this.pageNum = val;
      this.roleStuList();
    },
    // 查询学生列表
    async roleStuList() {
      console.log(111);
      //   return;
      this.loading = true;
      let {
        data: { status, msg, result },
      } = await this.$store.dispatch("userList", {
        identity: this.identity,
        otherParam: this.formInline.otherParam,
        name: this.formInline.name.trim(), //身份证号码
        keyId: this.formInline.keyId.trim(), //学工账号
        ksh: this.formInline.ksh.trim(), //考生号码
        campus: this.formInline.campus,
        hierarchy: this.formInline.hierarchy,
        grade: this.formInline.grade, //年级
        startTime:  this.formInline.LastexecutionTime?this.formInline.LastexecutionTime[0]:'',
        endTime: this.formInline.LastexecutionTime?this.formInline.LastexecutionTime[1]:'',
        cascade: this.formInline.cascade, //院/专/班
        college:
          this.formInline.cascade.length > 0
            ? this.formInline.cascade[0]
            : null, //院/专/班
        major:
          this.formInline.cascade.length > 1
            ? this.formInline.cascade[1]
            : null, //院/专/班
        className:
          this.formInline.cascade.length > 2
            ? this.formInline.cascade[2]
            : null, //院/专/班
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
      });
      this.loading = false;
      if (status === 1000) {
        if (result.data.length !== 0) {
          this.tableData = result.data;
          this.totalNum = result.count;
          this.reserveCount = result.numberImg;
          this.verifiedCount = result.number;
          this.totalLimit = result.total;
        } else {
          if (this.pageNum !== 1) {
            this.pageNum -= 1;
            this.roleStuList();
          } else {
            this.tableData = [];
            this.totalNum = 0;
          }
        }
        // this.getYjdrNum();
      } else {
        this.tableData = [];
        this.totalNum = 0;
      }
    },
  },
};
</script>

<style lang="scss" >
.STUDENT {
  .third .third-one {
    background: none;
    padding: 8px;
  }
  .error {
    color: red;
    text-decoration: underline;
    cursor: pointer;
  }
  .succ {
    color: #17c295;
  }
  .messageHistory-threeLine {
    .el-table__body-wrapper {
      height: calc(100vh - 230px) !important;
    }
  }
  .tableThree-height {
    .el-table__body-wrapper {
      height: calc(100vh - 328px) !important;
      .tableThree-height-shu {
        display: inline-block;
        padding: 0 4px;
        position: relative;
        .shu-item {
          position: absolute;
          width: 1px;
          height: 12px;
          background-color: #d4d4d7;
          display: inline-block;
          top: -10px;
        }
      }
    }
  }
  .do-btn-rightA {
    width: 200px;
    height: 100%;
    float: right;
    > p {
      font-size: 12px;
      display: inline-block;
      margin: 0;
      padding: 0 5px 0 0;
      // color: #333333 i !important;
      // color: red;
      // > span {
      //   color: royalblue;
      // }
      // > span:hover {
      //   text-decoration: underline;
      //   cursor: pointer;
      // }
    }
  }
  .serviceDialog {
    text-align: center;
    .el-dialog {
      top: 0 !important;
      margin: 0 auto 0px;
      // position: static;
      .el-dialog__body {
        padding: 16px;
        img {
          max-width: 100%;
        }
      }
    }
  }
  //图片上传对话框
  .openupimgg {
    width: 592px !important;
    overflow: hidden;
    .el-dialog {
      width: 100%;
      .el-dialog__header {
        border-bottom: 1px solid #d4d4d7;
        padding: 11px 16px;
        height: 44px;
        .el-dialog__title {
          font-size: 12px;
          color: #2e4057;
          font-weight: bold;
        }
        .el-dialog__headerbtn {
          position: absolute;
          top: 11px;
          right: 16px;
        }
      }
      .el-dialog__body {
        padding: 16px;
        > p {
          color: #aeaeb4;
          line-height: 28px;
          font-size: 12px;
          span {
            color: red;
          }
        }
        .el-form-item {
          margin-bottom: 8px;
        }
        .el-radio__label {
          padding-left: 4px;
        }
        .el-upload__tip {
          color: #aeaeb4;
          font-size: 12px;
        }
        .el-form-item__content {
          input {
            width: 393px;
          }
          > p {
            color: #aeaeb4;
            margin: 0;
            font-size: 12px;
          }
        }
        padding: 16px;
      }

      .el-dialog__footer {
        border-top: 1px solid #d4d4d7;
      }
    }
    margin: 0 auto;
  }
}
</style>
